import React, { Fragment, useEffect, useState } from "react";
import { Row, Table, Collapse } from "reactstrap";

import { InvestAssetClassTable } from "../InvestAssetClassTable/InvestAssetClassTable";
import arrow from "../../../../../public/svg/keyboard_arrow_down.svg";

import style from "./InvestSubAssetClassTable.scss";

export const InvestSubAssetClassTable = ({ offers, toggle, open }) => {
  return (
    <Fragment>
      <Row className={style.assetRow}>
        <Collapse className={open ? style.collapseActive : style.collapse} isOpen={open}>
          <InvestAssetClassTable offers={offers} toggle={toggle} />
        </Collapse>
      </Row>
    </Fragment>
  );
};
